
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { isEqual } from "lodash";
import VirtualOperatorSettingsModel from "@/types/sv-data/VirtualOperatorSettings";

@Component
export default class VirtualOperatorSettings extends Vue {
	@Prop({ default: () => ({ context: "", isConcluding: false }) })
	public value!: VirtualOperatorSettingsModel;

	private readonly contextMaxLength: number = 1000;
	private expanded: boolean = false;

	public settings: VirtualOperatorSettingsModel = { context: "", isConcluding: false };

	@Watch("value", { immediate: true })
	private onValueChanged(newValue: VirtualOperatorSettingsModel, oldValue: VirtualOperatorSettingsModel): void {
		if (!newValue) {
			this.settings = { context: "", isConcluding: false };
		} else if (!isEqual(newValue, oldValue)) {
			this.settings = { ...newValue };
		}
	}

	@Watch("settings", { deep: true })
	@Emit("input")
	private onSettingsChanged(): VirtualOperatorSettingsModel {
		return { ...this.settings };
	}
}
